import { components } from "@/api-schema";

type Branch = components["schemas"]["Branch"];
type Address = components["schemas"]["Address"];
type RelocationOrder = components["schemas"]["RelocationOrder"];

export interface RelocationOrderRoutePoint {
  key: "from" | "current" | "to";
  labelKey: "fit:From" | "fit:CurrentBranch" | "fit:To";
  branch: Branch | null | undefined;
  address?: Address | null;
  isCurrent?: boolean;
}

function areSameBranches(leftBranch: Branch | null | undefined, rightBranch: Branch | null | undefined): boolean {
  if (!leftBranch?.uuid || !rightBranch?.uuid) {
    return false;
  }

  return leftBranch.uuid === rightBranch.uuid;
}

export function getRelocationOrderRoutePoints(order: RelocationOrder): RelocationOrderRoutePoint[] {
  const currentBranch = order.currentBranch;
  const isOriginCurrent = areSameBranches(order.originBranch, currentBranch);
  const isDestinationCurrent = areSameBranches(order.destinationBranch, currentBranch);
  const routePoints: RelocationOrderRoutePoint[] = [
    {
      key: "from",
      labelKey: "fit:From",
      branch: order.originBranch,
      address: order.originAddress,
      isCurrent: isOriginCurrent,
    },
  ];

  if (currentBranch && !isOriginCurrent && !isDestinationCurrent) {
    routePoints.push({
      key: "current",
      labelKey: "fit:CurrentBranch",
      branch: currentBranch ?? null,
      address: order.currentAddress,
    });
  }

  routePoints.push({
    key: "to",
    labelKey: "fit:To",
    branch: order.destinationBranch,
    address: order.destinationAddress,
    isCurrent: isDestinationCurrent,
  });

  return routePoints;
}
